import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { ErrorMessage } from '../errorMessage';
/** Render an array of validation errors as error messages */

export var ValidationErrors = React.forwardRef(function (_ref, ref) {
  var validationErrors = _ref.validationErrors,
      className = _ref.className,
      icon = _ref.icon,
      scrollIntoView = _ref.scrollIntoView;
  var internalRef = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return internalRef.current;
  }, [internalRef]);
  React.useEffect(function () {
    var _a;

    if (validationErrors.length > 0 && scrollIntoView) {
      (_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
  }, [validationErrors.length]);
  /** If the error is a JSX element use the key on the element or the index */

  var getKey = React.useCallback(function (error, index) {
    var _a;

    if (typeof error === 'string') {
      return error + index;
    }

    return (_a = error === null || error === void 0 ? void 0 : error.key) !== null && _a !== void 0 ? _a : index;
  }, []);
  return React.createElement("div", {
    ref: internalRef,
    className: ClassNames.concat('arm-validation-errors', className)
  }, validationErrors.map(function (error, i) {
    return React.createElement(ErrorMessage, {
      message: error,
      key: getKey(error, i),
      icon: icon
    });
  }));
});